import { CheckCircle2 } from 'lucide-react';

export default function DownloadGo() {
  return (
    <div className="flex min-h-svh flex-col bg-[#1a1a1a]">
      <header className="flex items-center border-b border-[#2E3835] px-5 py-3">
        <img src="/logo.svg" alt="Watchful" className="h-7 w-auto" />
      </header>

      <main className="mx-auto flex w-full max-w-3xl flex-1 flex-col items-center justify-center px-8 pb-16 pt-10 text-center">
        <CheckCircle2 className="mb-7 h-16 w-16 text-lime" strokeWidth={1.5} />

        <h1 className="mb-3 text-3xl font-bold tracking-tight text-white">You're all set!</h1>
        <p className="mb-12 max-w-xs text-base leading-relaxed text-white/60">
          Your Watchful Go account has been created. Download the app to get started.
        </p>

        <div className="flex flex-col items-center gap-5">
          <a
            href="https://apps.apple.com/us/app/watchful-go/id6751511408"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="/watchful-go/app_store_black.svg"
              alt="Download on the App Store"
              className="h-[52px] w-auto"
            />
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.watchful.mobileapp"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="/watchful-go/play_store_black.svg"
              alt="Get it on Google Play"
              className="h-[52px] w-auto"
            />
          </a>
        </div>
      </main>
    </div>
  );
}
